import { render, staticRenderFns } from "./PatientEstimateFeeModal.vue?vue&type=template&id=ed70a88e&scoped=true"
import script from "./PatientEstimateFeeModal.vue?vue&type=script&lang=js"
export * from "./PatientEstimateFeeModal.vue?vue&type=script&lang=js"
import style0 from "./PatientEstimateFeeModal.vue?vue&type=style&index=0&id=ed70a88e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed70a88e",
  null
  
)

export default component.exports